import { UserInterface } from 'Interfaces'
import { Alert } from 'antd'

const Status = (id: string, record: UserInterface) => {
  const { isBanned } = record

  if (id === '' || !id) return null

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}
    >
      <Alert
        message={isBanned ? 'Prohibido' : 'Bloqueado'}
        type={isBanned ? 'warning' : 'error'}
        style={{ padding: '1px 12px', width: '6rem', textAlign: 'center' }}
        className="centerItem"
      />
    </div>
  )
}

export default Status
